<template>
    <div>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row class="mt-5">
            <v-col cols="12" md="8" sm="8">
                <div class="text-center">
                    <v-btn-toggle rounded v-model="toggleStatus">
                        <v-btn class="teal--text">{{ $t('ordered') }}</v-btn>
                        <v-btn class="orange--text">{{ $t('partial') }}</v-btn>
                        <v-btn class="green--text">{{ $t('completed') }}</v-btn>
                    </v-btn-toggle>
                </div>
            </v-col>

            <v-col cols="12" md="4" sm="4">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('search')"
                    single-line
                    hide-details
                ></v-text-field>
            </v-col>

            <v-col cols="12">
                <div class="text-center">
                    <v-pagination
                        v-model="currentPage"
                        :length="pageCount"
                        circle
                    ></v-pagination>
                </div>
            </v-col>

            <v-col
                v-for="(orderDoc,ind) in transactionProductOrderList"
                :key="ind"
                cols="12"
                md="3"
                sm="4"
            >
                <v-card>

                    <v-card-text>
                        <table>
                            <tr>
                                <td>{{ $t('client') }}</td>
                                <td> : </td>
                                <td> <h3>{{ orderDoc.client_name }}</h3> </td>
                            </tr>

                            <tr>
                                <td style=" vertical-align: top">{{ $t('address') }}</td>
                                <td style=" vertical-align: top"> : </td>
                                <td style="white-space: normal">{{ orderDoc.full_location }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('phone') }}</td>
                                <td> : </td>
                                <td> {{ orderDoc.client_phone | formatPhoneNumber}}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('supplier') }}</td>
                                <td> : </td>
                                <td> {{ orderDoc.supplier_name }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('supplierPhone') }}</td>
                                <td> : </td>
                                <td> {{ orderDoc.supplier_mobile | formatPhoneNumber }}</td>
                            </tr>

                             <tr>
                                <td>{{ $t('date') }}</td>
                                <td> : </td>
                                <td> {{ orderDoc.date }}</td>
                            </tr>

                             <tr>
                                <td>{{ $t('totalAmount') }}</td>
                                <td> : </td>
                                <td> <h3>{{ parseFloat(orderDoc.total_amount) | formatNumber }}{{getCurrencySymbol(orderDoc.currency_code) }} </h3></td>
                            </tr>

                        </table>

                        <v-progress-linear
                            v-if="orderDoc.status==='accepted'"
                            :value="calculatePercentReceive(orderDoc.transaction_order_line)"
                            height="13"
                            striped
                        >
                            <strong style="color: white">{{ Math.ceil(calculatePercentReceive(orderDoc.transaction_order_line)) }}%</strong>
                        </v-progress-linear>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn rounded small v-if="! (orderDoc.status=='accepted' || orderDoc.status=='completed')" color="primary" @click="handleProductTakeOut(orderDoc)">
                            {{ $t('takeOut') }}
                        </v-btn>
                        <v-btn rounded small v-if="orderDoc.status==='accepted'" color="success">
                            {{$t('done')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogProductTakeOut" persistent fullscreen style="background: wheat">
            <product-take-out :product-order-doc="detailDoc" v-if="dialogProductTakeOut" :is-edit="false" @handleCloseProductTakeOutForm="handleCloseProductTakeOutForm"></product-take-out>
        </v-dialog>

        <v-dialog v-model="dialogReceivePayment" persistent width="50%">
            <receive-payment :payment-doc="paymentObj" v-if="dialogReceivePayment" :is-edit="false" type="take-out" @handleCloseReceivePayment="handleCloseReceivePayment"></receive-payment>
        </v-dialog>
    </div>
</template>
<script>

    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import MainMixin from "../../../mixins/mainMixin";
    import ValidatorMixin from "../../../mixins/validatorMixin";
    import ProductTakeOut from "./productTakeOut";
    import ReceivePayment from "./receivePayment"

    import {provider} from "@/service/provider";
    import axios from "axios";
    import math from "math";
    import _ from "lodash";

    export default {
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        components: {ProductTakeOut, ReceivePayment},
        data() {
            return {
                dialogReceivePayment: false,
                search: "",
                dialogDetail: false,
                dialogProductTakeOut: false,
                detailDoc: {},
                toggleStatus: 0,
                tmpStatus: "order",
                paymentObj: {}
            };
        },
        methods: {
            calculatePercentReceive(list) {

                let order_qty = 0;
                let accepted_qty = 0;
                list.forEach((obj) => {
                    order_qty += parseFloat(obj.order_qty || 0);
                    accepted_qty += parseFloat(obj.accepted_qty || 0);
                })
                let percentTageReceive = math.round((accepted_qty / order_qty) * 100);
                return percentTageReceive;
            },
            handleCloseReceivePayment() {
                let vm = this;
                vm.dialogReceivePayment = false;
            },
            handleCloseProductTakeOutForm(d) {
                let vm = this;
                vm.dialogProductTakeOut = false;
                vm.fetchDataTable();
                if (d && d.isPayment === true) {
                    vm.getTransactionPaymentTermByTransactionId(d.transaction_take_out);
                }
            },
            getTransactionPaymentTermByTransactionId(id) {
                let url = provider.baseURL + provider.getDueTransactionPaymentTerm;
                let selector = {};
                selector.search = "";
                selector.transaction_id = id;
                selector.contact_id = "";
                selector.type_order = "";
                selector.offset = 0;
                selector.limit = 1;
                selector.due_date = "";
                selector.sort_by = "created_at";
                selector.sort_desc = 1;
                let vm = this;
                vm.overlay = true;
                return new Promise((resolve, reject) => {
                    axios.post(url, selector, {headers: {Authorization: localStorage.token}}).then(
                        res => {
                            if (res.data.response && res.data.response.code === 200) {
                                resolve(res.data.data[0]);
                                vm.paymentObj = res.data.data[0];
                                vm.dialogReceivePayment = true;
                            }
                            vm.overlay = false;

                        },
                        error => {
                            reject(error);
                            vm.overlay = false;

                        }
                    );
                });
            },

            fetchDataTable: _.debounce(function () {
                let vm = this;
                vm.fetchTransactionProductOrder({
                    search: vm.search,
                    id: "",
                    offset: vm.skip || 0,
                    limit: vm.itemsPerPage + (vm.skip || 0),
                    sortBy: "created_at",
                    sortDesc: 1,
                    status: vm.tmpStatus
                });
            }, 350),
            handleProductTakeOut(doc) {
                let vm = this;
                let url = provider.baseURL + provider.getListTransactionProductOrder;
                return new Promise((resolve, reject) => {
                    axios.post(url, {
                        search: "",
                        id: doc.id,
                        contact_id: "",
                        offset: 0,
                        type_order: "",
                        sort_by: "created_at",
                        sort_desc: 1,
                        limit: 1
                    }, {headers: {Authorization: localStorage.token}}).then(
                        res => {
                            if (res.data.response && res.data.response.code === 200) {
                                vm.detailDoc = {};
                                resolve(res.data.data);
                                let newItem = res.data.data[0];
                                vm.detailDoc = newItem;
                                vm.detailDoc.transaction_order_id = newItem.id;
                                vm.detailDoc.total_amount = parseFloat(vm.detailDoc.total_amount);
                                vm.detailDoc.deliverPercent = 0;
                                vm.detailDoc.transaction_order_line.map((d) => {
                                    d.currency_code = vm.detailDoc.currency_code;
                                    d.currency_symbol = vm.getCurrencySymbol(d.currency_code);
                                    d.order_qty = parseFloat(d.order_qty);
                                    d.price = parseFloat(d.price);
                                    d.total_amount = parseFloat(d.total_amount);
                                    return d;
                                })
                                vm.$nextTick(() => {
                                    vm.dialogProductTakeOut = true;
                                })
                            }
                        },
                        error => {
                            reject(error);
                        }
                    );
                });
            }

        },
        watch: {
            toggleStatus(val) {
                let vm = this;
                vm.tmpStatus = val === 0 ? "order" : val === 2 ? 'completed' : "partial";
                vm.fetchTransactionProductOrder({
                    search: vm.search,
                    id: "",
                    offset: vm.page,
                    limit: vm.itemsPerPage,
                    sortBy: "created_at",
                    sortDesc: 1,
                    status: vm.tmpStatus
                });
            },
            currentPage(val) {
                let vm = this;

                vm.fetchTransactionProductOrder({
                    search: vm.search,
                    id: "",
                    offset: val,
                    limit: vm.itemsPerPage,
                    sortBy: "created_at",
                    sortDesc: 1,
                    status: vm.tmpStatus

                });
            },
            search() {
                this.fetchDataTable();
            },


        },
        computed: {
            userDoc() {
                return this.$store.state.userDoc;
            }
        },
        created() {
            let vm = this;
            vm.itemsPerPage = 12;
            vm.fetchCurrencyOption();
            vm.fetchTransactionProductOrder({
                search: vm.search,
                id: "",
                offset: vm.page,
                limit: vm.itemsPerPage,
                sortBy: "created_at",
                sortDesc: 1,
                status: "order"
            });
        }
    };
</script>
